import {ActionPlanPage} from '#component/page/ActionPlan/ActionPlan.types';

import {
  ActionPlanFilterReference,
  ActionPlanFilters,
  ActionPlanFilterState,
} from './ActionPlanFilterModal.types';

export function getEmptyFilters(): ActionPlanFilters {
  return {
    categories: [],
    impactLevels: [],
  };
}

/**
 * Takes an array of action plan adjustments and calculates the possible filterable values
 */
export function getFilterReference(
  adjustments: ActionPlanPage.ActionPlanAdjustment[],
): ActionPlanFilterReference {
  return adjustments.reduce(
    (availableFilters, adj) => {
      const category = adj.healthFactorAssessment?.categoryAssessment?.category;
      const impactLevel = adj.impactLevel;

      if (category && !availableFilters.categories[category.id]) {
        availableFilters.categories[category.id] = category.title;
      }

      if (impactLevel && !availableFilters.impactLevels[impactLevel]) {
        availableFilters.impactLevels[impactLevel] = impactLevel;
      }
      return availableFilters;
    },
    {categories: {}, impactLevels: {}} as ActionPlanFilterReference,
  );
}

export function buildFilterState(
  filterReference: ActionPlanFilterReference,
  filters: ActionPlanFilters,
): ActionPlanFilterState {
  return {
    categories: Object.entries(filterReference.categories).map(([id, title]) => ({
      id,
      selected: filters.categories.includes(id),
      title,
    })),
    impactLevels: Object.entries(filterReference.impactLevels).map(([id, title]) => ({
      id,
      selected: filters.impactLevels.includes(id),
      title,
    })),
  };
}
